<template>
  <div>
    <b-navbar toggleable="sm" fixed="top" sticky="true" id="header">
      <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>
      <b-navbar-brand class="logo" style="font-size: 25px">
        <a href="/"><v-icon id="i-logo">mdi-xml</v-icon></a>
      </b-navbar-brand>
      <b-collapse id="nav-text-collapse" is-nav style="justify-content: end">
        <b-navbar-nav>
          <b-nav-text><a href="/#aboutme">About Me</a></b-nav-text>
          <b-nav-text><a href="/#mystack">Stack</a></b-nav-text>
          <b-nav-text><a href="/#portfolio">Portfolio</a></b-nav-text>
          <b-nav-text><a href="/#path">Experience</a></b-nav-text>
          <b-nav-text><a href="/#contactme">Contact Me</a></b-nav-text>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
window.onscroll = function () {
  scrollFunction();
};
export default {
  name: "NavHeader",
};
function scrollFunction() {
  if (
    document.body.scrollTop > 500 ||
    document.documentElement.scrollTop > 500
  ) {
    document.getElementById("header").style.background =
      "linear-gradient(to top, rgb(223, 233, 243) 0%, white 100%)";
    document.getElementById("i-logo").style.color = "black";
    document.getElementById("header").style.transitionProperty = "1s";
  } else {
    document.getElementById("header").style.background = "transparent";
    document.getElementById("i-logo").style.color = "#42b983";
  }
}
</script>

<style scoped>
#header {
  background: transparent;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
  transition: all ease-out 0.5s;
  padding: 8px 0px;
}

#i-logo {
  color: #42b983;
  margin: 0px 0px 5px 5px;
}

a {
  text-decoration: none;
}

nav {
  padding: 30px;
}

nav li a {
  font-weight: bold;
  text-decoration: none;
  transition: 0.3s;
  color: #42b983;
  margin: 20px;
}

nav li a:hover {
  color: black;
}

@media screen and (max-width: 922px) {
  nav li a {
    font-size: 12px;
  }
}

@media screen and (max-width: 829px) {
  nav li a {
    font-size: 5px;
  }
}

@media screen and (max-width: 575px) {
  nav li a {
    font-size: 15px;
  }

  #i-logo {
    color: black !important;
  }

  #header {
    background: linear-gradient(to top, #dfe9f3 0%, white 100%) !important;
  }
}
</style>
